// Module
var code = "<div class=\"abx-field-preloader__field\"> <div class=\"abx-field-preloader__pin-field\"> <div class=\"abx-field-preloader__circle\"></div> <div class=\"abx-field-preloader__circle-text abx-field-preloader__pin-text\" ng-class=\"'abx-field-preloader__pin-text--' + vm.labelSize\"></div> </div> </div> ";
// Exports
module.exports = code;